const convertAnyJson = (any, convert) => {
    switch (typeof any) {
        case 'object':
            if (any === null)
                return null;
            if (any instanceof Array)
                return any.map((item) => convertAnyJson(item, convert));
            if (any instanceof Date)
                return any;
            return convertJsonMap(any, convert);
        default:
            return any;
    }
};
const convertJsonMap = function (param, convert) {
    return Object.entries(param).reduce((acc, [key, value]) => {
        ;
        acc[convert(key)] = convertAnyJson(value, convert);
        return acc;
    }, {});
};
const convert = (param, convert) => {
    switch (typeof param) {
        case 'string':
            return convert(param);
        default:
            return convertJsonMap(param, convert);
    }
};
export default convert;
//# sourceMappingURL=convert.js.map